module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-background-2.5082588d.svg";